export const constants = {
  CHAT_ACTIVO: 'Active',
  CHAT_INACTIVO: '!Active',
  CAMBIO_USUARIO: 'warn.cambio.usuario',
  SESION_CHAT_VENCIDA: 'error.websvc.unknownEntity.session'
};
